import { render, staticRenderFns } from "./v3proto.vue?vue&type=template&id=bc57cf7e&scoped=true&"
import script from "./v3proto.vue?vue&type=script&lang=js&"
export * from "./v3proto.vue?vue&type=script&lang=js&"
import style0 from "./v3proto.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./v3proto.vue?vue&type=style&index=1&id=bc57cf7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc57cf7e",
  null
  
)

export default component.exports